export function pluralizeWord(word: string): string {
  if (word.endsWith('y')) {
    return word.slice(0, -1) + 'ies';
  } else if (
    word.endsWith('s') ||
    word.endsWith('x') ||
    word.endsWith('z') ||
    word.endsWith('ch') ||
    word.endsWith('sh')
  ) {
    return word + 'es';
  } else if (word.endsWith('f')) {
    return word.slice(0, -1) + 'ves';
  } else if (word.endsWith('fe')) {
    return word.slice(0, -2) + 'ves';
  } else if (word.endsWith('o') && !/(photo|piano|halo)$/.test(word)) {
    return word + 'es';
  } else if (word.endsWith('us')) {
    return word.slice(0, -2) + 'i';
  } else {
    return word + 's';
  }
}
